<template>
  <Modal
    size="full"
    width="6">
    <template #button="slotProps">
      <button
        type="button"
        @click="() => slotProps.openModal()"
        class="text-gray-600 hover:text-gray-900">
        <svg
          class="h-6 w-6"
          viewBox="-1 -1 17 17"
          fill="none"
          stroke="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.37892 10.2236L8 16L12.6211 10.2236C13.5137 9.10788 14 7.72154 14 6.29266V6C14 2.68629 11.3137 0 8 0C4.68629 0 2 2.68629 2 6V6.29266C2 7.72154 2.4863 9.10788 3.37892 10.2236ZM8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z"
          />
        </svg>
      </button>
    </template>
    <template #title>
      <div class="px-6 py-4 border-b bg-white">
        <div class="text-xs font-medium tracking-widest uppercase text-gray-400">
          Route Detail
        </div>
        <div class="mt-1 text-2xl font-semibold text-gray-900">
          {{ title }}
        </div>
        <div class="mt-1 text-sm text-gray-500">
          {{ date }}
        </div>
      </div>
    </template>
    <template #content>
      <div class="flex flex-col">
        <div class="flex justify-end mx-2">
          <!-- <a class="text-gray-500 hover:text-gray-900 hover:cursor-pointer"
            @click="openDetailInNewTab">
            Open in new tab
          </a> -->
          <button
            class="border !text-md px-3 py-2 bg-gray-50 transition-colors duration-300 rounded-l-md shadow-sm disabled:bg-gray-200 hover:bg-gray-100"
            @click="openDetail">
            Go To
          </button>
          <button
            class="border !text-md px-3 py-2 bg-gray-50 transition-colors duration-300 rounded-r-md shadow-sm disabled:bg-gray-200 hover:bg-gray-100"
            @click="openDetailInNewTab">
            New Window
          </button>
        </div>
        <RouteDetail
          :title="title"
          :routeId="routeId"
          :date="date"
          :direction="direction"
          :studentsProp="students"
          :showRouteTimes="showRouteTimes"
        />
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '../Modal.vue'
import RouteDetail from '../RouteDetail.vue'

export default {
  props: {
    title: String,
    routeId: Number,
    date: String,
    direction: String,
    students: Array,
    showRouteTimes: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Modal,
    RouteDetail,
  },
  methods: {
    openDetail() {
      console.log(this.routeId)
      this.$router.push({
        name: 'RouteDetail',
        params: {
          routeId: this.routeId,
          showRouteTimes: this.showRouteTimes,
        },
        query: {
          date: this.date,
          title: this.routeDetailTitle,
        }
      })
    },
    openDetailInNewTab() {
      console.log(this.routeId)
      const routeData = this.$router.resolve({
        name: 'RouteDetail',
        params: {
          routeId: this.routeId,
          showRouteTimes: this.showRouteTimes,
        },
        query: {
          date: this.date,
          title: this.routeDetailTitle,
        }
      })
      console.log(routeData.href)
      window.open(routeData.href, '_blank')
    },
  }
}
</script>
